module.exports = __webpack_public_path__ + "static/media/python.eb1d40d0.png";